export const formatNumber = {
    currencyFormat(
        value: string | number | null | undefined,
        language: 'DE' | 'EN' = 'DE'
    ) {
        if (!value && value !== 0) return value;

        const numericValue = typeof value === "string"
            ? parseFloat(value.replace(',', '.'))
            : value;

        if (isNaN(numericValue)) {
            return value;
        }

        const hasDecimals = numericValue % 1 !== 0;

        const locale = language === 'EN' ? 'en-US' : 'de-DE';

        return new Intl.NumberFormat(locale, {
            maximumFractionDigits: hasDecimals ? 2 : 0,
            minimumFractionDigits: hasDecimals ? 2 : 0,
        }).format(numericValue);
    },

    decimalConverter: {
        commaToDot(value: string | null | undefined): number | null {
            if (value === null || value === undefined) {
                return null;
            }
            return parseFloat(value.replace(',', '.'));
        },

        dotToComma(value: number | null | undefined, minDecimalPlaces: number = 1): string | null {
            if (value === null || value === undefined) {
                return null;
            }
            const concertedValue = value.toString().replace('.', ',');

            const decimalCount = concertedValue.includes(',')
                ? concertedValue.split(',')[1].length
                : 0;

            if (decimalCount && decimalCount < minDecimalPlaces) {
                return concertedValue + '0'.repeat(minDecimalPlaces - decimalCount);
            }

            return concertedValue;
        }
    }
};
